import axios from "axios";
import config from "../config"

export const ssoClient=axios.create({
    baseURL:config.ssoUrl
});
export const omrehBaseClient=axios.create({
    baseURL:config.omrehBaseUrl
});

ssoClient.interceptors.request.use((request) => {
    const token = localStorage.getItem("token") ?? null;
    request.headers.Authorization = `Bearer ${token}`
    return request;
});

omrehBaseClient.interceptors.request.use((request) => {
    const token = localStorage.getItem("token") ?? null;
    request.headers.Authorization = `Bearer ${token}`;
    request.headers["Accept-Language"] = "fa";
    return request;
});

omrehBaseClient.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.status && error.status === 401) {
        localStorage.clear();
        window.location.pathname = "/login";
    }
    return Promise.reject(error);
});